/* PEB — la soglia della spedizione, detta nel momento in cui serve: dentro il carrello.
   Nessuna urgenza finta, solo il conto di quanto manca. */
(function () {
  if (window.__pebShip) return; window.__pebShip = 1;
  var SOGLIA = 5990; // centesimi
  var st = document.createElement('style');
  st.textContent = '.peb-ship{margin:0 0 14px;padding:12px 14px;border-radius:12px;background:#F1F4E9;color:#33470E;font-size:15px;line-height:1.45}'
    + '.peb-ship.is-ok{background:#E7F0D8}'
    + '.peb-ship__bar{display:block;height:6px;border-radius:99px;background:rgba(74,100,22,.18);overflow:hidden;margin-bottom:8px}'
    + '.peb-ship__bar i{display:block;height:100%;background:#4A6416;border-radius:99px;transition:width .4s ease}';
  document.head.appendChild(st);

  function euro(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function paint(total) {
    var hosts = document.querySelectorAll('.cart-drawer__footer, .drawer__footer, .cart__footer, cart-drawer .drawer__footer');
    for (var i = 0; i < hosts.length; i++) {
      var h = hosts[i], el = h.querySelector('.peb-ship');
      if (!total || total <= 0) { if (el) el.remove(); continue; }
      if (!el) { el = document.createElement('div'); el.className = 'peb-ship'; h.insertBefore(el, h.firstChild); }
      var ok = total >= SOGLIA;
      var pct = Math.min(100, Math.round(total / SOGLIA * 100));
      el.className = 'peb-ship' + (ok ? ' is-ok' : '');
      el.innerHTML = '<span class="peb-ship__bar"><i style="width:' + pct + '%"></i></span>'
        + (ok
          ? 'La spedizione la offriamo noi, a domicilio o al punto di ritiro.'
          : 'Ti mancano <strong>' + euro(SOGLIA - total) + '</strong> e la spedizione la offriamo noi.');
    }
  }

  var busy = false;
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.total_price); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  if (document.readyState !== 'loading') refresh();
  document.addEventListener('DOMContentLoaded', refresh);

  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var a = arguments[0];
      var u = (typeof a === 'string') ? a : (a && a.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refresh, 200); });
    } catch (e) {}
    return p;
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('a[href*="/cart"], #cart-icon-bubble, .header__icon--cart, .cart-count-bubble') : null;
    if (t) setTimeout(refresh, 400);
  });
})();
